import { TextField } from '@mui/material';

interface PhoneInputProps {
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    helperText?: string;
    placeholder?: string;
}

export const formatPhoneDisplay = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} - ${digits.slice(6, 10)}`;
};

export default function PhoneInput({
    value,
    onChange,
    error,
    helperText,
    placeholder = '(555) 555 - 5555'
}: PhoneInputProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
        onChange(digits);
    };

    return (
        <TextField
            fullWidth
            value={formatPhoneDisplay(value)}
            onChange={handleChange}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            inputProps={{
                inputMode: 'tel',
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                    borderRadius: 2,
                    '& fieldset': {
                        borderColor: 'grey.300',
                    },
                    '&:hover fieldset': {
                        borderColor: 'grey.400',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#fbbf24',
                    },
                },
                '& .MuiInputBase-input': {
                    fontSize: '1.25rem',
                    letterSpacing: '0.05em',
                    lineHeight: 1.5,
                    color: 'grey.900',
                    '&::placeholder': {
                        color: 'grey.500',
                        opacity: 1,
                    },
                },
            }}
            FormHelperTextProps={{
                sx: {
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.75rem',
                }
            }}
        />
    );
}
